import React from 'react';
import { Stethoscope, Users, Award, ArrowRight } from 'lucide-react';
import { SectionProps, WithRefProps } from '../types';

const BenefitsHighlightsSection: React.FC<SectionProps & WithRefProps> = ({ inView, forwardedRef }) => {
  const handleCTAClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open('https://calendly.com/beratung-ciafardini-consulting/30min', '_blank');
  };

  return (
    <section id="benefits-highlights" className="section-padding bg-secondary-50">
      <div ref={forwardedRef} className={`container fade-up ${inView ? 'in-view' : ''}`}>
        <div className="text-center mb-12">
          <h2 className="font-bold mb-4">
            Entdecken Sie die Vorteile für Ihr Unternehmen
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Fewer Sick Days */}
          <div className="bg-white rounded-lg shadow-md p-8 transform hover:scale-[1.02] transition-all duration-300">
            <div className="flex justify-center mb-6">
              <div className="bg-primary-500 rounded-full p-4 inline-flex">
                <Stethoscope className="text-white w-8 h-8" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-4 text-center">Weniger Krankheitstage</h3>
            <p className="text-gray-700 text-center">
              Ein gesundes Team ist die Basis für nachhaltigen Unternehmenserfolg. Unterstützen Sie das Wohlbefinden Ihrer Mitarbeiter und steigern Sie die Teamleistung.
            </p>
          </div>
          
          {/* Higher Employee Retention */}
          <div className="bg-white rounded-lg shadow-md p-8 transform hover:scale-[1.02] transition-all duration-300">
            <div className="flex justify-center mb-6">
              <div className="bg-primary-500 rounded-full p-4 inline-flex">
                <Users className="text-white w-8 h-8" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-4 text-center">Höhere Mitarbeiterbindung</h3>
            <p className="text-gray-700 text-center">
              Zeigen Sie Ihrem Team, dass Sie sich um ihr Wohlergehen sorgen. Mitarbeiter, die sich umsorgt fühlen, bleiben länger und leisten mehr.
            </p>
          </div>
          
          {/* Attract Top Talent */}
          <div className="bg-white rounded-lg shadow-md p-8 transform hover:scale-[1.02] transition-all duration-300">
            <div className="flex justify-center mb-6">
              <div className="bg-primary-500 rounded-full p-4 inline-flex">
                <Award className="text-white w-8 h-8" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-4 text-center">Top-Talente gewinnen</h3>
            <p className="text-gray-700 text-center">
              Werden Sie zur ersten Wahl für qualifizierte Fachkräfte. Mit einem attraktiven Gesamtpaket ziehen Sie die besten Talente an und begeistern sie langfristig.
            </p>
          </div>
        </div>
        
        <div className="text-center mt-12">
          <a 
            href="#" 
            onClick={handleCTAClick}
            className="text-primary-500 font-medium hover:underline inline-flex items-center gap-2"
          >
            Das möchte ich für mein Unternehmen
            <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default BenefitsHighlightsSection;